import React from 'react'

import { Input, InputProps } from '@chakra-ui/react'

interface AiOperatorCriterionInputIProps extends Omit<InputProps, 'value'> {
  value: string
}

export const AiOperatorCriterionInput = ({
  value,
  isDisabled,
  ...rest
}: AiOperatorCriterionInputIProps) => {
  return (
    <Input
      _focus={{ border: 'none', boxShadow: 'none' }}
      _hover={{ border: 'none' }}
      backgroundColor={isDisabled ? '#F7FAFC' : 'white'}
      borderRadius='lg'
      cursor={isDisabled ? 'not-allowed' : 'default'}
      isDisabled={isDisabled}
      isReadOnly
      maxWidth={{
        base: '60px',
        sm: '80px',
        md: '130px',
        lg: '150px',
      }}
      minWidth={{
        base: '60px',
        sm: '80px',
        md: '130px',
        lg: '150px',
      }}
      pointerEvents='none'
      size='sm'
      tabIndex={-1}
      value={value}
      {...rest}
    />
  )
}
